import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import uuid from "uuid";

import AdvancedQuotingListItem from "./advancedQuotingListItem";
import {getFeatureGroupName} from "../../../misc/helpers";
import {wizardAllObjectInterface, wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {getWizardGroupName} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";

const AdvancedQuotingSubpartItems = (props) => {

  const {advancedCartItems, subPart, advancedCartItemsLength, allIds, allSqftIds, quoteIndex, intl, fabricatorData,
    qtCategoryName, stepIndex, wizardGroup, wizardAllObject, stepDisabled} = props;
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    setCartItems([...advancedCartItems])
    if (!advancedCartItems.length) {
      addEmptyCartItem(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancedCartItemsLength, allIds, allSqftIds]);

  const addEmptyCartItem = (keepPrevious) => {
    const currentCartItemsList = keepPrevious ? cartItems : [];
    setCartItems([...currentCartItemsList, {
      id: uuid.v4(),
      isEmpty: true,
      quantity: 0,
      partId: subPart.part.partId,
    }])
  };

  const deleteEmptyCartItem = (cartItem) => {
    const index = cartItems.findIndex(cItem => cItem.id === cartItem.id);
    if (index > -1) {
      cartItems.splice(index, 1);
    }
    setCartItems([...cartItems])
  };

  const isAddProductButtonVisible = ["room", "other_related_products", "slabs"].includes(subPart.part.partId)
    || stepDisabled;

  return (
    <Fragment>
      <h3 className={"scart-block__title scart-block__title--blue" + (stepDisabled ? " disabled2" : "")}>
        {wizardGroup
          ? getWizardGroupName(wizardGroup)
          : getFeatureGroupName(subPart.part, intl, fabricatorData)}
      </h3>
      <ul className={"scart-block__list" + (!cartItems.length ? " scart-block__list--hidden" : "")}>
        {cartItems.map((cartItem, cartItemIndex) => {
          return <AdvancedQuotingListItem cartItem={cartItem}
                                          subPart={subPart}
                                          key={cartItemIndex}
                                          quoteIndex={quoteIndex}
                                          deleteEmptyCartItem={deleteEmptyCartItem}
                                          qtCategoryName={qtCategoryName}
                                          stepIndex={stepIndex}
                                          wizardGroup={wizardGroup}
                                          stepDisabled={stepDisabled}
                                          wizardAllObject={wizardAllObject}/>
        })}
      </ul>
      {isAddProductButtonVisible && cartItems.length ? null : (
        <div className="dcart-advanced__add-button">
          <button className="ui-button2 ui-button2--gray-plus" onClick={addEmptyCartItem}>
            <FormattedMessage id="advancedQuoting.addProductButton"/>
          </button>
        </div>
      )}
    </Fragment>
  )
};

AdvancedQuotingSubpartItems.propTypes = {
  subPart: PropTypes.object.isRequired,
  advancedCartItems: PropTypes.array.isRequired,
  quoteIndex: PropTypes.number.isRequired,
  qtCategoryName: PropTypes.string,
  //wizard
  wizardAllObject: PropTypes.shape(wizardAllObjectInterface),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  stepIndex: PropTypes.number,
  stepDisabled: PropTypes.bool,
};

const mapStateToProps = (store, ownProps) => {
  return {
    advancedCartItemsLength: ownProps.advancedCartItems.length,
    allIds: ownProps.advancedCartItems.map((cartItem) => cartItem.id).join(),
    allSqftIds: ownProps.advancedCartItems.map((cartItem) => cartItem.sqftId).join(),
    fabricatorData: store.fabricatorState
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingSubpartItems)
);
